<template>
  <div class="container" style="background-color:#F2F5F9;">
    <SearchAndNav :coerceNavShow="true"></SearchAndNav>
    <div class="header">
      <!-- 轮播-->
      <!--      <Slider class="nav_content" :slideshow_imgs="slideshow_imgs" style="margin-top: 10px"></Slider>-->
      <div class="base_content nav_content">
        <Carousel autoplay loop :autoplaySpeed="3000">
          <CarouselItem v-for="item in slideshow_imgs" :key="item.id">
            <img :src="item.linkPic" style="object-fit: cover;background-repeat: no-repeat;width: 100%;height: 400px;cursor: pointer;max-width: 100%"  @click="jumpToBannerUrl(item.linkHref)">
          </CarouselItem>
        </Carousel>
        <div class="right-login-info">
          <div class="top-info-title">
            <div class="top-boxs-content-info">
              <div class="top-image" style="width: 42px;height: 42px;">
                <img src="../assets/touxiang.png" class="icon-image"/>
              </div>
              <div class="right-info-number">
                <span>hi,
                  <span v-if="isLoginBack" @click="toPersonalCenter" style="cursor: pointer;">{{ userInfo.username }}</span>
                </span>
                <span v-if="!isLoginBack">欢迎来到农产品集购网</span>
              </div>
            </div>
            <div v-if="!isLoginBack" class="bot-btn-two">
              <div class="zhuce-btn" @click="registerFun">免费注册</div>
              <div class="login-btn" @click="loginFun">马上登录</div>
            </div>
            <div v-else class="toPersonBtn">
              <Button @click="toPersonalCenter">进入个人中心</Button>
            </div>
          </div>
          <div class="flex-two-col-boxs">
            <div class="top-one-boxs">
              <div class="image-text">
                <img src="../assets/aqbz_green.png" class="image-icon">
                <div class="text-name">安全保障</div>
              </div>
              <div class="image-text">
                <img src="../assets/zskx_green.png" class="image-icon">
                <div class="text-name">真实可信</div>
              </div>
              <div class="image-text">
                <img src="../assets/jybj_green.png" class="image-icon">
                <div class="text-name">交易便捷</div>
              </div>
            </div>
            <div class="top-two-boxs">
              <div class="image-text">
                <img src="../assets/zjzc_green.png" class="image-icon">
                <div class="text-name">资金支持</div>
              </div>
              <div class="image-text">
                <img src="../assets/zzfw_green.png" class="image-icon">
                <div class="text-name">增值服务</div>
              </div>
              <div class="image-text">
                <img src="../assets/zsjy_green.png" class="image-icon">
                <div class="text-name">掌上交易</div>
              </div>
            </div>
          </div>
          <img src="../assets/not-400.png" style="padding-left: 7px;padding-top: 15px">
        </div>
      </div>
      <div style="clear: right"></div>
    </div>
    <div class="content">
      <!-- 现货推荐、价格信息、行情指数、供求信息-->
      <div class="base_out_k">
<!--        <realtime-price />-->
<!--        <div class="flex_display_between">-->
<!--          <market-chart :list="market_index" @selectType="selectTypeFun" @selectTypeDate="selectTypeDateFun"/>-->
<!--          <news/>-->
<!--        </div>-->
        <div class="flex_display_between" style="margin-bottom: 10px;">
<!--          <recommend :list="spot_recommendation"/>-->
          <div class="left-charts-box">
            <div class="top-zhe-xian">
              <div class="top-top-title">
                <div class="left-top-name">行情指数</div>
                <Select v-model="SPUIndex" style="width:200px" @on-change="getSpotIndexBack">
                  <Option v-for="item in SPUArray" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </div>
              <div class="charts-box">
                <qiun-vue-ucharts
                  type="line"
                  :opts="optsZX"
                  :chartData="chartDataZX"
                />
              </div>
            </div>
            <div class="bot-content-big-map">
              <div style="color: #666666; padding: 20px">
                <span>{{ yesterdayDate }}日均价</span>
                <span style="color: #FF2E30">{{yesterdayAvgPrice}}</span>
                <span>元/吨</span>
              </div>
              <div class="bot-map-content">
                <qiun-vue-ucharts
                  type="map"
                  canvas-id="product-map"
                  canvas2d
                  :chart-data="echartDataMap"
                  :opts="optsMap"
                  in-scroll-view
                  :page-scroll-top="pageScrollTop"
                  tooltip-format="mapFormatter"
                />
              </div>
              <div class="bot-left-color">
                <div class="for-big-left" v-for="(item, index) in legendList" :key="index">
                  <div class="left-color" :style="{backgroundColor: item.color}"></div>
                  <div class="right-text">{{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <transaction/>
            <buying/>
          </div>
        </div>
        <div class="tejia-box">
          <div class="title">今日特价</div>
          <div class="big-tejia-box">
             <div class="item-box" v-for="(item, index) in tejiaList" :key="index" @click="goDetail(item)">
               <img :src="item.productUrl" class="img">
               <div class="title-name">{{ item.productName }}</div>
               <div class="money-box">
                 <div class="left">
                   <span style="color: #FF2E30">¥</span>
                   <span class="span-money">{{ item.saleUnitPrice }}</span>
                   <span>元/{{ item.measureUnit }}</span>
                 </div>
                 <div class="right">¥{{ item.bargainPrice }}</div>
               </div>
             </div>
          </div>
        </div>
        <partners/>
        <div style="display: flex;margin-bottom: 20px">
          <img src="@/assets/xh.png"/>
          <img style="margin-left: 11px" src="@/assets/hq.png"/>
          <img style="margin-left: 11px" src="@/assets/wl.png"/>
          <img style="margin-left: 11px" src="@/assets/zn.png"/>
        </div>
      </div>
      <!-- 安全保障-->
<!--      <div style="margin: 40px 0;justify-content: space-around" class="flex_display">-->
<!--        <div class="flex_display_item">-->
<!--          <div class="flex_display_item_block">-->
<!--            <img src="../../static/img/home/safe.png" alt="" style="vertical-align: middle;width: 40px;height: 40px;">-->
<!--            <span style="vertical-align: middle;font-size: 20px;color: #666">安全保障</span>-->
<!--          </div>-->
<!--          <div class="flex_display_item_none">-->
<!--            <span>1.资金安全</span>-->
<!--            <span>2.产品安全</span>-->
<!--            <br/>-->
<!--            <span>3.交易安全</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="flex_display_item">-->
<!--          <div class="flex_display_item_block">-->
<!--            <img src="../../static/img/home/real.png" alt="" style="vertical-align: middle;width: 40px;height: 40px;">-->
<!--            <span style="vertical-align: middle;font-size: 20px;color: #666">真实可信</span>-->
<!--          </div>-->
<!--          <div class="flex_display_item_none">-->
<!--            <span>1.第三方监管</span>-->
<!--            <span>2.认证企业</span>-->
<!--            <br/>-->
<!--            <span>3.交易透明</span>-->
<!--            <span>4.质检机构护航</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="flex_display_item">-->
<!--          <div class="flex_display_item_block">-->
<!--            <img src="../../static/img/home/fast.png" alt="" style="vertical-align: middle;width: 40px;height: 40px;">-->
<!--            <span style="vertical-align: middle;font-size: 20px;color: #666">交易便捷</span>-->
<!--          </div>-->
<!--          <div class="flex_display_item_none">-->
<!--            <span>1.权威信息指导</span>-->
<!--            <span>2.人脉聚集</span>-->
<!--            <br/>-->
<!--            <span>3.品类聚集</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="flex_display_item">-->
<!--          <div class="flex_display_item_block">-->
<!--            <img src="../../static/img/home/vip.png" alt="" style="vertical-align: middle;width: 40px;height: 40px;">-->
<!--            <span style="vertical-align: middle;font-size: 20px;color: #666">增值服务</span>-->
<!--          </div>-->
<!--          <div class="flex_display_item_none">-->
<!--            <span>1.农业资讯</span>-->
<!--            <span>2.信息技术</span>-->
<!--            <br/>-->
<!--            <span>3.专业团队的管理式服务</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 置顶-->
      <div class="top" id="top" @click="toTop">
        <img src="../../static/img/home/top.png" alt="" style="width: 20px;height: 20px;" class="top1">
        <img src="../../static/img/home/top_h.png" alt="" style="width: 20px;height: 20px;" class="top2">
        <div>
          <span style="color: #666">顶部</span>
        </div>
      </div>
    </div>
    <LoginPop v-if="isLogin" @closeDialog="isLogin = false"></LoginPop>
  </div>
</template>

<script>
import china from '../components/Index/mock/china.json'
import { getSpotIndexList, getSpotMap, getAvgPrice, bargainList } from '@/api/content'
import qiunVueUcharts from '@qiun/vue-ucharts'
import store from '@/vuex/store';
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import changeTitle from '@/components/hm_personal/ChangeTitle';
import SearchAndNav from '@/components/header/SearchAndNav';
import LoginPop from '@/components/hm_personal/LoginPop';
import {
  apiGetSlideShow,
  apiGetSpotRecommendation,
  apiGetSupplyDemand,
  apiGetContentInformaton,
  apiGetJobber, apiGetMarketIndex
} from '@/api/hm';
import {getToken} from '@/utils/auth';
import RealtimePrice from '@/components/Index/realtimePrice.vue';
import MarketChart from '@/components/Index/marketChart.vue';
import Recommend from '@/components/Index/recommend.vue';
import Transaction from '@/components/Index/transaction.vue';
import Partners from '@/components/Index/partners.vue';
import Buying from '@/components/Index/buying.vue';
import News from '@/components/Index/News.vue';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';

export default {
  name: 'Index',
  components: {
    qiunVueUcharts,
    News,
    Buying,
    Partners,
    Transaction,
    Recommend,
    MarketChart,
    RealtimePrice,
    changeTitle,
    SearchAndNav,
    LoginPop
  },
  data () {
    return {
      tejiaList: [],
      // 这是地图
      china,
      yesterdayAvgPrice: 0,
      yesterdayDate: '',
      echartDataMap: {},
      legendList: [
        { color: '#40A789', text: '成交量>1000吨' },
        { color: '#3CC19A', text: '500吨<成交量<1000吨' },
        { color: '#54E1B7', text: '100吨<成交量<5000吨' },
        { color: '#BCEEDF', text: '成交量<100吨' }
      ],
      // 地图配置
      optsMap: {
        color: ['#40A789', '#3CC19A', '#54E1B7', '#BCEEDF', '#DEE5F1'],
        padding: [0, 0, 0, 0],
        dataLabel: true,
        enableScroll: false,
        fontSize: 8,
        fontColor: '#fff',
        extra: {
          tooltip: {
            legendShow: false,
            boxPadding: 10,
            borderRadius: 8,
            bgOpacity: 0.4
          },
          map: {
            border: true,
            mercator: true, // 是否进行WGS84转墨卡托投影(开启后可能会造成tooltip不跟手，建议自行转换)
            borderWidth: 1,
            borderColor: '#DEE5F1',
            fillOpacity: 1,
            activeBorderColor: '#FEA65E',
            activeFillColor: '#FEA65E',
            activeFillOpacity: 1
          }
        }
      },
      pageScrollTop: 0, // 页面时候必须传入pageScrollTop，inScrollView传true，否则会导致地图某些事件不触发
      // 这是地图
      // 这是折线图数据---start
      SPUIndex: 0,
      SPUArray: [{value: 0, label: '东北豆'}, {value: 1, label: '白砂糖'}],
      chartDataZX: {},
      optsZX: {
        color: ['#A7D27D'],
        padding: [20, 20, 20, 10],
        enableScroll: false,
        dataLabel: false, // 数据显示
        dataPointShape: false, // 圆点显示
        legend: {
          show: false
        },
        series: {
          show: false,
          textColor: '#444'
        },
        xAxis: {
          fontColor: '#999',
          fontSize: 10,
          labelCount: 6
        },
        yAxis: {
          data: [
            {
              fontColor: '#999',
              fontSize: 11
            }
          ]
        },
        extra: {
          line: {
            type: 'straight',
            width: 2,
            activeType: 'hollow'
          }
        }
      },
      // 这是折线图数据----end
      selectTypeFunType: 0, // 品类type
      selectTypeDateFunType: 0, // 时间type
      token: '', // 用户token
      isLogin: false,
      code: '',
      jc_code: '153',
      cx_code: '155',
      zx_code: '149',
      bg_code: '157',
      supplyLength: 20,
      demandLength: 20,
      jobberLength: 20,
      is_g_click: true,
      is_q_click: false,
      slideshow_imgs: [],
      advertising_imgs: [],
      market_index: [],
      spot_recommendation: [],
      potatoEchartsParams: {
        fatherName: '农资果蔬数据',
        sonName: '蔬菜行业',
        varName: '马铃薯',
        attrute: '主产区价格',
        location: '平均价',
        minTime: '20230101',
        maxTime: '20231231'
      },
      soybeansEchartsParams: {
        fatherName: '油脂油料行业',
        sonName: '种植业',
        varName: '大豆',
        attrute: '现货报价',
        location: '全国',
        minTime: '20230101',
        maxTime: '20231231'
      },
      whiteSugarEchartsParams: {
        fatherName: '糖及食品行业',
        sonName: '加工业',
        varName: '白砂糖',
        attrute: '价格',
        location: '全国',
        minTime: '20230101',
        maxTime: '20231231'
      },
      supply: [],
      demand: [],
      jobber: [],
      title_arr1: ['产区价格'],
      title_arr2: ['销区价格'],
      title_arr3: ['行情综述'],
      title_arr4: ['热点专题'],
      title_arr5: ['苗情长势'],
      title_arr6: ['出口数据', '进口数据'],
      title_arr7: ['产量数据', '销量数据'],
      title_arr8: ['周报', '月报', '年报'],
      title_arr9: ['国际资讯', '电商资讯', '农业头条', '技术资讯'],
      title_arr10: ['战略合作商'],
      // 价格信息
      cq: [],
      xq: [],
      // 马铃薯行情
      scbd: [],
      hqzs: [],
      hqfx: [],
      // 资讯信息
      hyzx: [],
      sjzx: [],
      jszx: [],
      qtzx: [],
      zxxx: [],
      // 进出口数据信息
      cksj: [],
      jksj: [],
      jcksj: [],
      // 产销量数据信息
      clsj: [],
      xlsj: [],
      cxlsj: [],
      // 研究报告
      rb: [],
      zb: [],
      nb: [],
      rznb: [],
      isEnd16988com: location.host.endsWith('16988.com')
    };
  },
  store,
  watch: {
    '$store.state.token': {
      immediate: true,
      handler (v) {
        if (v != '') {
          this.token = v;
        }
      }
    },
    'token': {
      immediate: true,
      handler (v) {
        if (v) {
          if (!this.userInfo.username) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$store.state.userInfo = userInfo;
          }
        }
      }
    }
  },
  computed: {
    isLoginBack () {
      return !!Cookies.get('loginToken');
    },
    userInfo () {
      return this.$store.state.userInfo;
    },
    ...mapState(['seckills', 'computer', 'eat', 'marketing']),
    ...mapGetters(['seckillsHours', 'seckillsMinutes', 'seckillsSeconds'])
  },
  created () {
    this.loadCarouselItems();
    // 轮播
    this.getSlideShow();
    // 广告位
    this.getAdvertisingShow();
    // 行情指数
    this.getMarketIndex();
    // 现货推荐
    this.getSpotRecommendation();
    //供求信息、经纪人
    this.getScrollInformation();
    // 内容信息
    this.getContentInformationCQ();
    this.getContentInformationXQ();
    this.getContentInformationSCBD();
    this.getContentInformationHQZS();
    this.getContentInformationHQFX();
    this.getContentInformationZX();
    this.getContentInformationJC();
    this.getContentInformationCX();
    this.getContentInformationRZNB();
  },
  mounted () {
    this.bargainListFun()
    this.getAvgPrice()
    this.getSpotIndex()
    this.getSpotMap()
  },
  methods: {
    ...mapActions(['loadSeckillsInfo', 'loadCarouselItems', 'loadComputer', 'loadEat', 'loadShoppingCart']),
    ...mapMutations(['REDUCE_SECKILLS_TIME']),
    // 跳转商品详情
    goDetail (item) {
      this.$router.push({ path: `/GoodsDetail?id=${item.id}` });
    },
    // 特惠商品列表
    bargainListFun() {
      bargainList().then(res => {
        if(res.code === 200) {
          this.tejiaList = res.data
          this.tejiaList.forEach(item => {
            item.deliveryType = item.deliveryType.split(',')
            item.tradeType = item.tradeType.split(',')
          })
          console.log(this.tejiaList);
        }
      })
    },
    // 品种一切切两个
    getSpotIndexBack() {
      this.getAvgPrice()
      this.getSpotIndex()
      this.getSpotMap()
    },
    // 获取均价
    async getAvgPrice() {
      const res = await getAvgPrice({
        productName: this.SPUArray[this.SPUIndex].label
      })
      this.yesterdayAvgPrice = res.data ? res.data.avgPrice : '-'
      this.yesterdayDate = res.data ? res.data.date : '-'
    },
    // 获取指数地图
    async getSpotMap() {
      const res = await getSpotMap({
        productName: this.SPUArray[this.SPUIndex].label
      })
      const mapData = res.data || []
      this.drawChina(mapData)
    },

    // 绘制中国地图
    drawChina(mapData) {
      const china = this.china
      const series = china.features.map((item) => {
        const data = mapData.find((map) =>
          map.provinceName.includes(item.properties.name)
        ) || { quantity: 0, price: 0 }
        const quantityColors = {
          '#40A789': 1000,
          '#3CC19A': 500,
          '#54E1B7': 100,
          '#BCEEDF': 0,
          '#DEE5F1': -Infinity
        }

        const color =
          Object.keys(quantityColors).find((c) => data.quantity > quantityColors[c]) ||
          '#DEE5F1'
        return { ...item, value: data.quantity, fillOpacity: 1, color, price: data.price }
      })
      this.echartDataMap = { series }
    },
    // 获取现货指数
    async getSpotIndex() {
      const res = await getSpotIndexList({
        productName: this.SPUArray[this.SPUIndex].label,
        startDate: dayjs().add(-180, 'day').format('YYYY-MM-DD 00:00:00'),
        endDate: dayjs().format('YYYY-MM-DD 00:00:00')
      })
      if (res.data && res.data.length) {
        const categories = []
        const series = [
          {
            name: '现货指数',
            data: []
          }
        ]
        res.data.forEach((item) => {
          const endDateBack = item.endDate.split('-')
          const newEndDateBack = `${endDateBack[0].substring(2, 4)}.${endDateBack[1]}.${
            endDateBack[2]
          }`
          categories.push(newEndDateBack)
          series[0].data.push(item.price)
        })
        this.chartDataZX = {
          categories,
          series
        }
      } else {
        this.chartDataZX = null
      }
    },
    viewDetail (id) {
      // if (!getToken()) {
      //   this.isLogin = true;
      // } else {
      // this.isLogin = false;
      this.$router.push({
        path: '/GoodsDetail',
        query: {
          id
        }
      });
      // }
    },
    // 选择品类
    selectTypeFun (val) {
      this.selectTypeFunType = val;
      this.getMarketIndex(val, '品类');
    },
    // 选择时间
    selectTypeDateFun (val) {
      this.selectTypeDateFunType = val;
      this.getMarketIndex(val, '时间');
    },
    // 登陆
    loginFun () {
      this.$router.push('/UserLogin');
    },
    // 注册
    registerFun () {
      this.$router.push('/UserRegister');
    },
    toPersonalCenter () {
      // 前往个人中心页面
      if (!this.isLoginBack) return;
      this.$router.push('/PersonalCenter');
    },
    sgClick () {
      let index = this.is_g_click === true ? 0 : 1;
      this.$router.push({
        path: 'supplyanddemand',
        query: {
          index
        }
      });
    },
    jumpToBannerUrl (url) {
      if (url) {
        window.open(url)
      }
    },
    titleClick (item) {
      switch (item) {
        case '行业资讯':
          this.zx_code = 149;
          break;
        case '商机资讯':
          this.zx_code = 150;
          break;
        case '技术资讯':
          this.zx_code = 151;
          break;
        case '其他资讯':
          this.zx_code = 152;
          break;
        case '出口数据':
          this.jc_code = 153;
          break;
        case '进口数据':
          this.jc_code = 154;
          break;
        case '产量数据':
          this.cx_code = 155;
          break;
        case '消费数据':
          this.cx_code = 156;
          break;
        case '日报':
          this.cx_code = 157;
          break;
        case '周报':
          this.cx_code = 158;
          break;
        case '年报':
          this.cx_code = 159;
          break;
      }
    },
    getSlideShow () {
      const params = {
        type: 0,
        isShow: 1
      };
      apiGetSlideShow(params).then(
        res => {
          this.slideshow_imgs = res.data.records
        }
      )
    },
    getAdvertisingShow () {
      const params = {
        type: 1,
        isShow: 1
      };
      apiGetSlideShow(params).then(
        res => {
          // this.advertising_imgs = (res.data.records.reduce((total, item) => {
          //   return total + ',' + item.linkPic.split(',');
          // }, '')).split(',').splice(1, 3);
          if (res.data && res.data.records && res.data.records.length > 0) {
            const ress = res.data.records.filter(item => item.sort == 1);
            if (ress && ress.length > 0) {
              this.advertising_imgs = [ress[0].linkPic];
            }
          }
        }
      );
    },
    getMarketIndex (valueData, valueName) {
      let valueDataBack = valueData || 0;
      let valueNameBack = valueName || '品类';
      let month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
      let params = {};
      if (valueNameBack === '品类') {
        switch (valueDataBack) {
          case 0:
            params = this.potatoEchartsParams;
            params.minTime = this.getMinTime();
            break;
          case 1:
            params = this.soybeansEchartsParams;
            params.minTime = this.getMinTime();
            break;
          case 2:
            params = this.whiteSugarEchartsParams;
            params.minTime = this.getMinTime();
            break;
        }
      }
      if (valueNameBack === '时间') {
        const start = new Date();
        switch (valueDataBack) {
          case 0:
            let startBack = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            let minTimeBack = dayjs(startBack).format('YYYYMMDD');
            params = this.selectTypeFunType === 0 ? this.potatoEchartsParams : this.selectTypeFunType === 1 ? this.soybeansEchartsParams : this.whiteSugarEchartsParams;
            params.minTime = minTimeBack;
            break;
          case 1:
            let startBackTwo = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            let minTimeBackTwo = dayjs(startBackTwo).format('YYYYMMDD');
            params = this.selectTypeFunType === 0 ? this.potatoEchartsParams : this.selectTypeFunType === 1 ? this.soybeansEchartsParams : this.whiteSugarEchartsParams;
            params.minTime = minTimeBackTwo;
            break;
          case 2:
            let startBackThree = start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            let minTimeBackThree = dayjs(startBackThree).format('YYYYMMDD');
            params = this.selectTypeFunType === 0 ? this.potatoEchartsParams : this.selectTypeFunType === 1 ? this.soybeansEchartsParams : this.whiteSugarEchartsParams;
            params.minTime = minTimeBackThree;
            break;
          case 3:
            let startBackFour = start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            let minTimeBackFour = dayjs(startBackFour).format('YYYYMMDD');
            params = this.selectTypeFunType === 0 ? this.potatoEchartsParams : this.selectTypeFunType === 1 ? this.soybeansEchartsParams : this.whiteSugarEchartsParams;
            params.minTime = minTimeBackFour;
            break;
        }
      }
      params.maxTime = `${new Date().getFullYear()}${month}${date}`;
      apiGetMarketIndex(params).then(res => {
        let data = res.data.data.data
        // ------------如果是马铃薯，则将数据乘以2000，从元/斤转为元/吨（以便于统一 元/吨 的单位）-------------
        if(res.data.data.varName === '马铃薯'){
          data = data.map(i=>{
            return {...i,'平均价':i['平均价']*2000}
          })
        }
        this.market_index = data;
        this.drawLine();
      });
    },
    getMinTime () {
      const start = new Date();
      let startBack = null;
      let minTimeBack = null;
      if (this.selectTypeDateFunType === 0) {
        startBack = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        minTimeBack = dayjs(startBack).format('YYYYMMDD');
      } else if (this.selectTypeDateFunType === 1) {
        startBack = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        minTimeBack = dayjs(startBack).format('YYYYMMDD');
      } else if (this.selectTypeDateFunType === 2) {
        startBack = start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        minTimeBack = dayjs(startBack).format('YYYYMMDD');
      } else {
        startBack = start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        minTimeBack = dayjs(startBack).format('YYYYMMDD');
      }
      return minTimeBack;
    },
    getSpotRecommendation () {
      const params = {
        pageNum: 1,
        pageSize: 20
      };
      apiGetSpotRecommendation(params).then(
        res => {
          res.data.records.forEach(item => {
            if (item.productUrl) {
              item.productUrl = item.productUrl.split(',')[0];
            }
          });
          this.spot_recommendation = res.data.records;
        }
      );
    },
    async getSupplyDemand (type) {
      let params = {
        pageNum: 1,
        pageSize: 20,
        auditStatus: 2
      };
      params.dataType = type === 'supply' ? 0 : 1;
      params.dataPermission = 0;
      await apiGetSupplyDemand(params).then(
        res => {
          this[type] = res.data.records;
          if (type === 'supply') {
            if (res.data.records.length > 6) {
              this.supplyLength = res.data.records.length;
            }
          } else {
            if (res.data.records.length > 6) {
              this.demandLength = res.data.records.length;
            }
          }
        }
      );
    },
    async getScrollInformation () {
      //供求信息
      await this.getSupplyDemand('supply');
      await this.getSupplyDemand('demand');
      //经纪人
      await this.getJobber('jobber');
      this.scroll();
    },
    async getContentInformationCQ () {
      await this.contentInformaton('cq');
      this.cq = [this.cq];
    },
    async getContentInformationXQ () {
      await this.contentInformaton('xq');
      this.xq = [this.xq];
    },
    async getContentInformationSCBD () {
      await this.contentInformaton('scbd');
      this.scbd = [this.scbd];
    },
    async getContentInformationHQZS () {
      await this.contentInformaton('hqzs');
      this.hqzs = [this.hqzs];
    },
    async getContentInformationHQFX () {
      await this.contentInformaton('hqfx');
      this.hqfx = [this.hqfx];
    },
    async getContentInformationZX () {
      await this.contentInformaton('hyzx');
      await this.contentInformaton('sjzx');
      await this.contentInformaton('jszx');
      await this.contentInformaton('qtzx');
      this.zxxx.push(this.hyzx, this.sjzx, this.jszx, this.qtzx);
    },
    async getContentInformationJC () {
      await this.contentInformaton('cksj');
      await this.contentInformaton('jksj');
      this.jcksj.push(this.cksj, this.jksj);
    },
    async getContentInformationCX () {
      await this.contentInformaton('clsj');
      await this.contentInformaton('xlsj');
      this.cxlsj.push(this.clsj, this.xlsj);
    },
    async getContentInformationRZNB () {
      await this.contentInformaton('rb');
      await this.contentInformaton('zb');
      await this.contentInformaton('nb');
      this.rznb.push(this.rb, this.zb, this.nb);
    },
    async contentInformaton (type) {
      let params;
      switch (type) {
        // 产区
        case 'cq':
          params = {
            categoryCode: '143',
            dataType: 0,
            hasShow: 1
          };
          break;
        // 销区
        case 'xq':
          params = {
            categoryCode: '144',
            dataType: 0,
            hasShow: 1
          };
          break;
        // 市场报道
        case 'scbd':
          params = {
            categoryCode: '146',
            dataType: 1,
            hasShow: 1
          };
          break;
        // 行情综述
        case 'hqzs':
          params = {
            categoryCode: '147',
            dataType: 1,
            hasShow: 1
          };
          break;
        // 行情分析
        case 'hqfx':
          params = {
            categoryCode: '148',
            dataType: 1,
            hasShow: 1
          };
          break;
        // 行业资讯
        case 'hyzx':
          params = {
            categoryCode: '149',
            dataType: 2,
            hasShow: 1,
            pageSize: 16
          };
          break;
        // 商机资讯
        case 'sjzx':
          params = {
            categoryCode: '150',
            dataType: 2,
            hasShow: 1,
            pageSize: 16
          };
          break;
        // 技术资讯
        case 'jszx':
          params = {
            categoryCode: '151',
            dataType: 2,
            hasShow: 1,
            pageSize: 16
          };
          break;
        // 其他资讯
        case 'qtzx':
          params = {
            categoryCode: '152',
            dataType: 2,
            hasShow: 1,
            pageSize: 16
          };
          break;
        // 出口数据
        case 'cksj':
          params = {
            categoryCode: '153',
            dataType: 3,
            hasShow: 1
          };
          break;
        // 进口数据
        case 'jksj':
          params = {
            categoryCode: '154',
            dataType: 3,
            hasShow: 1
          };
          break;
        // 产量数据
        case 'clsj':
          params = {
            categoryCode: '155',
            dataType: 3,
            hasShow: 1
          };
          break;
        // 销量数据
        case 'xlsj':
          params = {
            categoryCode: '156',
            dataType: 3,
            hasShow: 1
          };
          break;
        // 日报
        case 'rb':
          params = {
            categoryCode: '157',
            dataType: 4,
            hasShow: 1
          };
          break;
        // 周报
        case 'zb':
          params = {
            categoryCode: '158',
            dataType: 4,
            hasShow: 1
          };
          break;
        // 年报
        case 'nb':
          params = {
            categoryCode: '159',
            dataType: 4,
            hasShow: 1
          };
          break;
      }
      await apiGetContentInformaton(params).then(
        res => {
          let path;
          let record = res.data.records.map(item => {
            switch (params.categoryCode) {
              // 产区
              case '143':
              // 销区
              case '144':
                path = 'Pricedetails';
                break;
              // 市场报道
              case '146':
              // 行情综述
              case '147':
              // 行情分析
              case '148':
                path = 'marketquotatimetePricedetails';
                break;
              // 行业资讯
              case '149':
              // 商机资讯
              case '150':
              // 技术资讯
              case '151':
              // 其他资讯
              case '152':
                path = 'RealtimePricedetails';
                break;
              // 出口数据
              case '153':
              // 进口数据
              case '154':
              // 产量数据
              case '155':
              // 销量数据
              case '156':
                path = 'ExportdataPricedetails';
                break;
              // 日报
              case '157':
              // 周报
              case '158':
              // 年报
              case '159':
                path = 'researchreportPricedetails';
                break;
            }
            return {
              id: item.id,
              title: item.title,
              createTime: item.createTime.substring(5, 10),
              path: path
            };
          });
          if (type === 'cq' || type === 'xq') {
            this[type] = record.splice(0, 4);
          } else if (type === 'hyzx' || type === 'sjzx' || type === 'jszx' || type === 'qtzx') {
            this[type] = record.splice(0, 16);
          } else {
            this[type] = record.splice(0, 8);
          }
        }
      );
    },
    async getJobber (type) {
      let params = {
        pageNum: 1,
        pageSize: 20,
        auditStatus: 2
      };
      params.dataPermission = 0;
      await apiGetJobber(params).then(
        res => {
          this[type] = res.data.records;
          if (res.data.records.length > 6) {
            this.jobberLength = res.data.records.length;
          }
        }
      );
    },
    drawLine () {
      const myChart = this.$echarts.init(document.getElementById('myChart'));
      let data = this.market_index.map(item => {
        item.timeInt = String(item.timeInt);
        let year = item.timeInt.substring(0, 4);
        let month = item.timeInt.substring(4, 6);
        let date = item.timeInt.substring(6, 8);
        let time = +new Date([year, month, date].join('-'));
        return [
          time, item['平均价']
        ];
      });
      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          },
          padding: 0,
          backgroundColor: 'transparent',
          borderWidth: 0,
          formatter: function (params) {
            let time_data = params[0].data[0];
            let month = new Date(time_data).getMonth() + 1 < 10 ? '0' + (new Date(time_data).getMonth() + 1) : new Date(time_data).getMonth() + 1;
            let date = new Date(time_data).getDate() < 10 ? '0' + new Date(time_data).getDate() : new Date(time_data).getDate();
            let time = new Date(time_data).getFullYear() + '-' + month + '-' + date;
            let res = '';
            res += `
                <div style="width: 100px;height: 42px;border-radius: 2px;padding: 0;background-color:rgba(0,0,0,0.502);color: #fff;">
                   <div style="padding-left: 10px">
                      ${time}
                   </div>
                   <div style="padding-left: 10px">
                      <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#EE4533"></span>
                      <span>${params[0].data[1]}</span>
                  </div>
                </div>
            `;
            return res;
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        series: [
          {
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#EE4533'
            },
            areaStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(238,69,51,0.12)'
                },
                {
                  offset: 1,
                  color: 'rgba(238,69,51,0)'
                }
              ])
            },
            data: data
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    gQClick (is_show, is_no_show) {
      this[is_show] = true;
      this[is_no_show] = false;
    },
    tb_row_class_name (row, index) {
      if (index % 2 !== 0) {
        return 'tb_row_class_name';
      }
    },
    toTop () {
      document.documentElement.scrollTop = 0;
    },
    scroll () {
      let that = this;
      const table1 = document.getElementById('table1_scroll');
      var table1_body = (table1 && table1.getElementsByClassName('ivu-table-body')) ? table1.getElementsByClassName('ivu-table-body') : null;

      const table2 = document.getElementById('table2_scroll');
      var table2_body = (table2 && table2.getElementsByClassName('ivu-table-body')) ? table2.getElementsByClassName('ivu-table-body') : null;

      const table3 = document.getElementById('table3_scroll');
      var table3_body = (table3 && table3.getElementsByClassName('ivu-table-body')) ? table3.getElementsByClassName('ivu-table-body') : null;

      var timer1 = null;
      var timer2 = null;
      var timer3 = null;

      function play (table, length) {
        return (
          setInterval(function () {
            table[0].scrollTop++;
            if ((table[0].scrollTop) >= (46 * length - 46 * 6 - 5)) {
              table[0].scrollTop = 0;
            }
          }, 100)
        );
      }

      function play1 (table) {
        clearInterval(timer1);
        timer1 = play(table, that.supplyLength);
      }

      function play2 (table) {
        clearInterval(timer2);
        timer2 = play(table, that.demandLength);
      }

      function play3 (table) {
        clearInterval(timer3);
        timer3 = play(table, that.jobberLength);
      }

      if (table1_body) {
        setTimeout(play1(table1_body), 500);
      }
      if (table2_body) {
        setTimeout(play2(table2_body), 500);
      }
      if (table3_body) {
        setTimeout(play3(table3_body), 500);
      }

      if (table1) {
        table1.onmouseover = function () {
          clearInterval(timer1);
        };
        table1.onmouseout = function () {
          play1(table1_body);
        };
      }

      if (table2) {
        table2.onmouseover = function () {
          clearInterval(timer2);
        };
        table2.onmouseout = function () {
          play2(table2_body);
        };
      }

      if (table3) {
        table3.onmouseover = function () {
          clearInterval(timer3);
        };
        table3.onmouseout = function () {
          play3(table3_body);
        };
      }

    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
}

.header {
  width: 1200px;
  height: 385px;
  margin: 0 auto;
}

.content {
  width: 1200px;
  margin: auto;
  background-color: #F2F5F9;
  color: #333;
  font-size: 12px;

  /deep/ .ivu-table-row-hover td {
    background-color: #F7FBF5 !important;
  }
}

.padding_16_20 {
  padding: 16px 20px;
}

.padding_14_20 {
  padding: 14px 20px;
}

.padding_12_20 {
  padding: 12px 20px;
}

.color_999 {
  color: #999;
}

.shop-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.font_size_14 {
  font-size: 14px;
}

.flex_display {
  display: flex;
  cursor: pointer;

  .flex_display_item {
    flex: 1;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .flex_display_item_none {
      display: none;
      color: #61A842;
      font-size: 14px;
      padding-left: 34px;
      padding-right: 30px;
    }

    &:hover {
      .flex_display_item_block {
        display: none;
      }

      .flex_display_item_none {
        display: block;
      }
    }
  }
}

.flex_display_between {
  display: flex;
  justify-content: space-between;
  .left-charts-box{
    width: 596px;
    background: #FFFFFF;
    .top-zhe-xian{
      padding: 20px 18px;
      .top-top-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left-top-name{
          font-weight: 800;
          font-size: 18px;
          color: #333333;
        }
      }
      .charts-box{
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        margin-top: 20px;
        width: 560px;
        height: 280px;
        background: linear-gradient(to bottom, #F5FFEF, #FFFFFF);
      }
    }
  }
  .bot-content-big-map{
    margin: 0 20px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background: linear-gradient(to bottom, #F5FFEF, #FFFFFF);
    .bot-map-content{
      position: absolute;
      width: 400px;
      height: 400px;
      margin-left: 85px;
    }
    .bot-left-color{
      position: relative;
      top: 330px;
      left: 20px;
      .for-big-left{
        display: flex;
        align-items: center;
        .left-color{
          width: 24px;
          height: 13px;
          border-radius: 3px;
        }
        .right-text{
          font-size: 12px;
          color: #999999;
          margin-left: 8px;
        }
      }
    }
  }
}

.tejia-box{
  padding: 21px 24px;
  background: #FFFFFF;
  margin-bottom: 10px;
  .title{
    font-size: 18px;
    color: #333333;
  }
  .big-tejia-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;
    .item-box{
      .img{
        display: block;
        width: 180px;
        height: 180px;
      }
      .title-name{
        margin-top: 7px;
        width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 800;
        font-size: 14px;
        color: #1F1F1F;
      }
      .money-box{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .left{
          font-weight: 800;
          font-size: 12px;
          color: #999999;
          .span-money{
            font-weight: bold;
            font-size: 24px;
            color: #FF2E30;
          }
        }
        .right{
          text-decoration: line-through;
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
}

.base_ellipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.base_out_k {
}

.base_head_title {
  font-size: 20px;
  font-weight: 700;

  img {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 5px;
  }

  span {
    vertical-align: middle;
  }
}

/*-------------------------------------------------------------*/

#myChart {
  position: relative;
  top: -20px;
}

.nav_content {
  width: 100%;
  float: right;
  position: relative;
  right: 240px;
  top: 10px;

  .right-login-info {
    position: absolute;
    top: -2px;
    right: -240px;
    width: 232px;
    height: 366px;
    background-color: #FFFFFF;

    .top-info-title {
      padding-top: 30px;
      .top-boxs-content-info {
        display: flex;
        align-items: center;
        margin-left: 25px;

        .right-info-number {
          flex: 1;
          margin-left: 11px;
          font-size: 12px;
        }
      }

      .bot-btn-two {
        display: flex;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
        margin: 15px 0;

        .login-btn {
          width: 96px;
          height: 28px;
          box-sizing: border-box;
          color: #FFFFFF;
          font-size: 14px;
          background: #61A842;
          border-radius: 1px;
          text-align: center;
          line-height: 28px;
        }

        .zhuce-btn {
          width: 96px;
          height: 28px;
          background: #FFFFFF;
          color: #61A842;
          margin-left: 10px;
          border: 1px solid #61A842;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          border-radius: 1px;
          box-sizing: border-box;
        }
      }

      .toPersonBtn {
        display: flex;
        justify-content: center;
        margin: 10px 0;
        .ivu-btn {
          width: 180px;
          background: #61A842;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    .flex-two-col-boxs {
      padding: 0 14px;
      .top-one-boxs {
        display: flex;
        align-items: center;

        .image-text {
          padding: 10px;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-top: 1px solid #E4E4E4;
          .image-icon {
            width: 23px;
            height: 23px;
          }

          .text-name {
            padding-top: 7px;
            font-size: 12px;
            color: #333333;
          }
        }
      }

      .top-two-boxs {
        display: flex;
        align-items: center;

        .image-text {
          padding: 10px;
          padding-bottom: 0;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          .image-icon {
            width: 23px;
            height: 23px;
          }

          .text-name {
            padding-top: 7px;
            font-size: 12px;
            color: #333333;
          }
        }
      }
    }
  }
}

.recommend_content {
  width: 246px;
  //padding: 10px 0 0;
  background-color: #fff;

  .item {
    width: 246px;
    padding: 12px 0 0;
    background-color: #fafafa;
    border: 1px solid #EEEEEE;

    .head {
      border-bottom: 1px solid #EEEEEE;
      padding: 0 12px;

      img {
        width: 44px;
        height: 44px;
      }

      .title {
        font-size: 16px;
      }

      .price {
        color: #EE4533;
        font-weight: 700;
      }

      .place {
        font-size: 12px;
        color: #999999;
      }
    }

    .body {
      padding: 0 12px;
    }

    .button {
      height: 37px;
      line-height: 37px;
      text-align: center;
      color: #61A842;
      border-top: 1px solid #eee;
      cursor: pointer;
    }

    .button:hover {
      background: #F7FBF5;
      border: 1px solid #61A842;
    }
  }
}

.gq {
  height: 462px;
}

.gq_content {
  .button {
    display: flex;
    float: left;
    width: 130px;
    height: 30px;
    line-height: 27px;
    background-color: #eee;
    padding: 2px;
    border-radius: 2px 2px 2px 2px;
    cursor: pointer;
    border-radius: 2px 2px 2px 2px;

    .g, .q {
      flex: 1;
      text-align: center;
      color: #666666;
      border-radius: 2px 2px 2px 2px;
    }

    .g_q_click {
      background-color: #fff;
      color: #61A842;
      font-weight: 700;
    }
  }

}

.top {
  width: 52px;
  height: 52px;
  position: fixed;
  bottom: 50px;
  right: 0;
  background-color: #fff;
  text-align: center;
  padding: 6px 0;
  cursor: pointer;
}

.top1 {
  display: inline-block;
}

.top2 {
  display: none;
}

.top:hover {
  .top2 {
    display: inline-block;
  }

  .top1 {
    display: none;
  }

  span {
    color: #61A842 !important;
  }
}

.container {
  /deep/ .ivu-table td {
    height: 46px;
    color: #333333;
    font-size: 14px;
  }

  /deep/ .ivu-table {
    td:nth-child(2) {
      &:hover {
        color: #61A842 !important;
      }
    }
  }

  /deep/ .ivu-table-cell {
    white-space: nowrap;
  }

  /deep/ .ivu-table-header {
    th {
      background-color: #F8F8F8;
      color: #999999;
    }
  }

  /deep/ .ivu-table .tb_row_class_name td {
    background-color: #FAFAFA;
  }

  /deep/ .table_scroll .ivu-table-body {
    overflow: hidden;
    height: 277px;
  }
}

.more_hover_img1 {
  display: inline-block;
}

.more_hover_img2 {
  display: none;
}

.more_hover:hover {
  span {
    color: #333 !important;
  }

  .more_hover_img1 {
    display: none;
  }

  .more_hover_img2 {
    display: inline-block;
  }
}

.base_content {
  height: 364px;
  width: 750px;
  /deep/ {
    .ivu-carousel-list {
      height: 364px;
      width: 750px;
    }

    .ivu-carousel-item {
      height: 364px !important;
      width: 750px;
    }

    .ivu-carousel-dots-inside {
      bottom: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue